module.exports = __webpack_public_path__ + "img/sync.058183a6.svg";